import baseApi from 'shared/utils/baseApi';

export function withClientId<T>(params: T) {
    return {
        client_id: baseApi.clientId || '',
        ...params,
    };
}
